import Swiper from 'swiper'
import { Thumbs, Zoom, Navigation, Keyboard } from 'swiper/modules'

const parseSlides = (button) => {
  try {
    const slides = JSON.parse(button.getAttribute('data-workshop-preview-slides'))
    return Array.isArray(slides) ? slides.filter((slide) => slide && slide.src) : []
  } catch {
    return []
  }
}

// Titles are admin-authored, so they must not be able to close the attribute.
const escapeAttr = (value) =>
  String(value ?? '').replace(/[&<>"']/g, (char) => `&#${char.charCodeAt(0)};`)

const slideHtml = ({ src, alt }) => `
  <div class="swiper-slide">
    <div class="swiper-zoom-container">
      <img class="workshop-preview__image" src="${escapeAttr(src)}" alt="${escapeAttr(alt)}">
    </div>
  </div>`

const thumbHtml = ({ src, thumb, alt }) => `
  <div class="swiper-slide workshop-preview__thumb">
    <img src="${escapeAttr(thumb || src)}" alt="${escapeAttr(alt)}">
  </div>`

const initWorkshopPreview = () => {
  const modal = document.getElementById('workshop-preview-modal')
  if (!modal) return

  const main = modal.querySelector('[data-workshop-preview-main]')
  const thumbs = modal.querySelector('[data-workshop-preview-thumbs]')
  if (!main || !thumbs) return

  let mainSwiper = null
  let thumbsSwiper = null

  const destroy = () => {
    mainSwiper?.destroy(true, true)
    thumbsSwiper?.destroy(true, true)
    mainSwiper = null
    thumbsSwiper = null
    main.querySelector('.swiper-wrapper').innerHTML = ''
    thumbs.querySelector('.swiper-wrapper').innerHTML = ''
  }

  const openPreview = (slides) => {
    if (!slides.length) return

    destroy()
    // Strip is pointless for a single image (poster, or a workshop with no gallery).
    modal.classList.toggle('has-thumbs', slides.length > 1)

    main.querySelector('.swiper-wrapper').innerHTML = slides.map(slideHtml).join('')
    thumbs.querySelector('.swiper-wrapper').innerHTML = slides.map(thumbHtml).join('')

    modal.classList.remove('hidden')
    modal.setAttribute('aria-hidden', 'false')
    document.body.classList.add('overflow-hidden')

    if (slides.length > 1) {
      thumbsSwiper = new Swiper(thumbs, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        watchSlidesProgress: true,
        centerInsufficientSlides: true,
      })
    }

    mainSwiper = new Swiper(main, {
      modules: [Thumbs, Zoom, Navigation, Keyboard],
      // toggle: false — the click handler below owns zooming; Swiper's own
      // double-tap toggle would fire on the same gesture and undo it.
      zoom: { maxRatio: 4, toggle: false },
      keyboard: { enabled: true },
      navigation: {
        nextEl: main.querySelector('.swiper-button-next'),
        prevEl: main.querySelector('.swiper-button-prev'),
      },
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
    })

    // Click to toggle zoom, matching the previous preview behaviour.
    mainSwiper.on('click', () => {
      if (mainSwiper.zoom.scale > 1) {
        mainSwiper.zoom.out()
      } else {
        mainSwiper.zoom.in()
      }
    })
  }

  const closePreview = () => {
    modal.classList.add('hidden')
    modal.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('overflow-hidden')
    destroy()
  }

  document.querySelectorAll('[data-workshop-preview-slides]').forEach((button) => {
    button.addEventListener('click', () => openPreview(parseSlides(button)))
  })

  modal.querySelectorAll('[data-workshop-preview-close]').forEach((button) => {
    button.addEventListener('click', closePreview)
  })

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.classList.contains('hidden')) {
      closePreview()
    }
  })
}

export default initWorkshopPreview
